const nav = require('../../src/data/globals/nav.json');
const blog = require('../../src/data/globals/blog.json');

module.exports = (options) => {
  return options.fn({
    nav,
    blog
  });
};